import React from "react";

export default function AuthBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      {/* Mobile/Tablet (< 1024px) */}
      <svg
        viewBox="0 0 390 844"
        preserveAspectRatio="xMidYMid slice"
        className="h-full w-full lg:hidden"
        aria-hidden="true"
      >
        <rect width="390" height="844" fill="#FFFFFF" />

        {/* TOP-LEFT PINK BLOB */}
        <path
          d="
            M 0 0
            L 118 0
            C 112 42, 108 70, 116 110
            C 126 162, 140 200, 124 262
            C 104 336, 56 370, 16 392
            C 8 396, 3 398, 0 398
            Z
          "
          fill="#FDE9EB"
        />

        {/* TOP RIBBON (gold) */}
        <path
          d="
            M 150 0
            C 165 40, 170 85, 170 130
            C 170 190, 158 240, 145 265
            C 105 350, 60 385, 0 395
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* BOTTOM-RIGHT PINK BLOB */}
        <path
          d="
            M 390 844
            L 180 844
            C 220 824, 210 806, 230 778
            C 340 728, 360 700, 370 688
            C 374 682, 400 680, 390 678
            Z
          "
          fill="#FDE9EB"
        />

        {/* BOTTOM RIBBON (gold with gentle S-bend) */}
        <path
          d="
            M 220 850
            C 255 750, 310 770, 350 750
            S 400 680, 400 650
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* BOTTOM LEFT RIBBON */}
        <path
          d="
            M 0 650
            C 80 680, 150 720, 145 790
            C 145 830, 140 840, 140 844
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Desktop (≥ 1024px) */}
      <svg
        viewBox="0 0 1920 1080"
        preserveAspectRatio="xMidYMid slice"
        className="hidden h-full w-full lg:block"
        aria-hidden="true"
      >
        <rect width="1920" height="1080" fill="#FFFFFF" />



{/* TOP-RIGHT PINK BLOB */}
        <path
          d="
            M 1920 0
            L 1620 0
            C 1595 55, 1610 115, 1640 175
            C 1680 250, 1655 320, 1600 385
            C 1560 430, 1540 475, 1565 520
            C 1590 565, 1650 590, 1720 610
            C 1780 625, 1850 630, 1920 635
            Z
          "
          fill="#FDE9EB"
        />

{/* TOP-RIGHT RIBBON (gold) */}
        <path
          d="
            M 1490 0
            C 1470 45, 1450 90, 1455 135
            C 1460 180, 1440 225, 1445 270
            C 1455 330, 1485 395, 1540 450
            C 1605 515, 1695 565, 1780 590
            C 1835 605, 1880 615, 1920 620
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="3.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      {/* TOP-LEFT PINK BLOB - Scaled for desktop */}
        <path
          d="
            M 0 0
            L 378 0
            C 360 72, 342 126, 369 198
            C 405 288, 441 360, 396 468
            C 333 603, 180 666, 54 706.5
            C 27 715.5, 9 720, 0 720
            Z
          "
          fill="#FDE9EB"
        />

        {/* TOP RIBBON (gold) - Scaled for desktop */}
        <path
          d="
            M 495 0
            C 531 72, 549 153, 549 234
            C 549 342, 508.5 432, 468 477
            C 342 630, 198 693, 0 711
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="3.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />


        {/* BOTTOM-RIGHT PINK BLOB - Scaled for desktop */}
        <path
          d="
            M 1920 1080
            L 1200 1080
            C 1350 1040, 1320 1010, 1380 950
            C 1650 880, 1720 820, 1780 790
            C 1800 775, 1900 770, 1920 765
            Z
          "
          fill="#FDE9EB"
        />

        {/* BOTTOM RIBBON (gold) - Scaled for desktop */}
        <path
          d="
            M 1100 1100
            C 1220 950, 1480 990, 1680 950
            S 1920 820, 1920 750
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* BOTTOM LEFT RIBBON - Scaled for desktop */}
        <path
          d="
            M 0 800
            C 352 860, 660 920, 638 1000
            C 638 1050, 616 1070, 616 1080
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}